import { Component, ComponentArgs } from "@kluntje/core";
import { getParent, addClass, removeClass, hasClass, find, onEvent } from "@kluntje/js-utils/lib/dom-helpers";
import { ACTIVE, SCROLL_LOCK } from "Helper/cssClasses";
import CookieService from "Services/CookieService";
import {focusUponElement} from "Helper/domHelper/focusHelper";

export class FraOverlay extends Component {
  static readonly CLOSE_EVENT = "fra-overlay-close";

  static readonly OPEN_EVENT = "fra-overlay-open";

  static readonly OVERLAY_OPENED_COOKIE = "fra-overlay-opened";

  static readonly INITIALLY_OPEN_ATTRIBUTE = "initially-open";

  constructor({ ui = {}, events = [], initialStates = {}, reactions = {} }: ComponentArgs = {}) {
    super({
      ui: {
        header: ".fra-js-overlay__header :-one",
        ...ui,
      },
      events: [
        {
          event: "click",
          target: "this",
          handler: "handleClick",
        },
        {
          event: "keyup",
          target: "window",
          handler: "handleKeyup",
        },
        ...events,
      ],
      initialStates,
      reactions,
    });
  }

  /**
   * renders closing icon into overlay
   * @override
   */
  afterComponentRender(): void {
    const icon = document.createElement("fra-e-icon");
    addClass(icon, "fra-m-overlay__close-icon", "fra-js-overlay__close-icon");
    icon.setAttribute("icon-id", "fra-icon-close");

    if (this.ui.header) {
      this.ui.header.appendChild(icon);
    } else {
      this.appendChild(icon);
    }

    const closeIcon = find(this, ".fra-js-overlay__close-icon");

    onEvent(
      closeIcon,
      "click",
      () => {
        this.close();
      },
      this,
    );

    this.showOverlayInitially();
  }

  /**
   * handles click on overlay, by optionally closing it
   * @param {Event} e
   */
  handleClick(e: Event): void {
    if (e.target === this && !hasClass(this, "fra-js-header__overlay")) {
      this.close();
    }
  }

  showOverlayInitially(): void {
    if (this.hasAttribute(FraOverlay.INITIALLY_OPEN_ATTRIBUTE)) {
      const page = getParent(this, ".fra-m-page");
      addClass(page, "fra-m-darksite-active");

      const cookieValue = this.getAttribute(FraOverlay.INITIALLY_OPEN_ATTRIBUTE) || "";
      if (!CookieService.isCookieValueSet(FraOverlay.OVERLAY_OPENED_COOKIE, cookieValue)) {
        CookieService.setCookie(FraOverlay.OVERLAY_OPENED_COOKIE, cookieValue, 7);
        this.open();
      }
    }
  }

  /**
   * opens Overlay by adding ACTIVE Class to it and disables scrolling of page
   */
  open(): void {
    addClass(document.body, SCROLL_LOCK);
    addClass(this, ACTIVE);
    focusUponElement(this);
    this.dispatchEvent(new Event(FraOverlay.OPEN_EVENT));
    window.dispatchEvent(new Event("fra-toggled-layer-open"));
  }

  /**
   * closes Overlay by removing ACTIVE Class from it and enables scrolling of page
   */
  close(): void {
    removeClass(document.body, SCROLL_LOCK);
    removeClass(this, ACTIVE);
    this.dispatchEvent(new Event(FraOverlay.CLOSE_EVENT));
  }

  /**
   * Handles KeyboardEvents and closes overlay on ESC
   * @param {KeyboardEvent} e
   */
  handleKeyup(e: KeyboardEvent): void {
    if (e.key === "Escape") this.close();
  }
}

customElements.define("fra-m-overlay", FraOverlay);
